import { render, staticRenderFns } from "./hzIndex.vue?vue&type=template&id=ad208816&scoped=true"
import script from "./hzIndex.vue?vue&type=script&lang=js"
export * from "./hzIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad208816",
  null
  
)

export default component.exports